// Description: Render The Menu Content of the sidebar
// Updated: 18/09/2025

// React
import * as React from "react";

// Material UI Components
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";

// Components and Functions for the project
import { useNavigate, useLocation } from "react-router-dom";
import { checkAuth } from "../../utils/utils";
import use123zapStore from "../../context/123zapStore";

const mainListItems = [
  {
    text: "Dashboard",
    icon: (
      <svg
        id="bold"
        enable-background="new 0 0 32 32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <g fill="#5F1BBC">
          <circle cx="10" cy="20.333" r="1" />
          <path d="m11.5 24h-3c-.276 0-.5-.224-.5-.5 0-.827.673-1.5 1.5-1.5h1c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5z" />
          <circle cx="16" cy="20.333" r="1" />
          <path d="m17.5 24h-3c-.276 0-.5-.224-.5-.5 0-.827.673-1.5 1.5-1.5h1c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5z" />
          <circle cx="22" cy="20.333" r="1" />
          <path d="m23.5 24h-3c-.276 0-.5-.224-.5-.5 0-.827.673-1.5 1.5-1.5h1c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5z" />
        </g>
        <path
          d="m22.167 8h-12.334c-1.011 0-1.833.822-1.833 1.833v6.333c0 1.012.822 1.834 1.833 1.834h12.333c1.012 0 1.834-.822 1.834-1.833v-6.334c0-1.011-.822-1.833-1.833-1.833zm-9.5 6h-2.667c-.368 0-.667-.299-.667-.667s.299-.666.667-.666h2.667c.368 0 .667.299.667.667s-.299.666-.667.666zm1.333-2.667h-4c-.368 0-.667-.299-.667-.667s.299-.666.667-.666h4c.368 0 .667.299.667.667s-.299.666-.667.666zm2 1.667c0-1.613 1.147-2.96 2.667-3.267v2.993l-2.113 2.113c-.347-.526-.554-1.159-.554-1.839zm3.333 3.333c-.68 0-1.313-.207-1.84-.547l2.313-2.313c.121-.126.194-.293.194-.473v-3.267c1.52.307 2.667 1.653 2.667 3.267 0 1.84-1.494 3.333-3.334 3.333z"
          fill="#5F1BBC"
        />
      </svg>
    ),

    path: "/painel",
  },
  {
    text: "Canais",
    icon: (
      <svg
        enable-background="new 0 0 32 32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <path
          d="m23.991 8.524c.001-.067-.01-.132-.035-.194-.006-.014-.007-.028-.014-.041-.031-.06-.071-.117-.126-.162-.008-.007-.018-.009-.027-.015-.005-.004-.007-.01-.012-.013-.01-.007-.023-.005-.034-.011-.058-.033-.119-.054-.184-.061-.018-.002-.035-.007-.053-.007-.077-.001-.153.014-.224.048-.005.002-.01.001-.014.003l-15 7.833c-.174.091-.279.275-.268.471s.136.367.319.438l4.908 1.9.948 4.947c.003.014.01.025.014.038.006.021.014.041.023.062.017.039.038.074.063.107.008.01.01.023.019.032.005.005.011.007.016.012.045.046.095.086.155.112.003.001.006.001.009.002.046.019.094.033.145.038.016.001.032.002.047.002.057 0 .111-.012.163-.03.015-.005.028-.014.043-.021.038-.017.073-.038.106-.065.007-.006.015-.008.022-.014l3.606-3.238 3.557 1.285c.055.02.113.03.17.03.094 0 .188-.027.269-.078.131-.083.215-.223.229-.377l1.167-13c.001-.01-.007-.021-.007-.033zm-9.157 13.26-.627-3.271 6.143-6.143-4.431 6.701c-.019.029-.035.06-.048.092z"
          fill="#5F1BBC"
        />
      </svg>
    ),
    path: "/canais",
  },
  {
    text: "Listagens",
    icon: (
      <svg
        enable-background="new 0 0 32 32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <g fill="#5F1BBC">
          <path d="m9.167 12h3.667c.643 0 1.166-.523 1.166-1.167v-1.666c0-.644-.523-1.167-1.167-1.167h-3.666c-.644 0-1.167.523-1.167 1.167v1.667c0 .643.523 1.166 1.167 1.166z" />
          <path d="m9.167 18h3.667c.643 0 1.166-.523 1.166-1.167v-1.667c0-.643-.523-1.166-1.167-1.166h-3.666c-.644 0-1.167.523-1.167 1.167v1.667c0 .643.523 1.166 1.167 1.166z" />
          <path d="m9.167 24h3.667c.643 0 1.166-.523 1.166-1.167v-1.667c0-.643-.523-1.166-1.167-1.166h-3.666c-.644 0-1.167.523-1.167 1.167v1.667c0 .643.523 1.166 1.167 1.166z" />
        </g>
        <g fill="#5F1BBC">
          <path d="m23.5 8.333h-7.667c-.276 0-.5.224-.5.5s.224.5.5.5h7.667c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z" />
          <path d="m23.5 10.333h-7.667c-.276 0-.5.224-.5.5s.224.5.5.5h7.667c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z" />
          <path d="m23.5 14.333h-7.667c-.276 0-.5.224-.5.5s.224.5.5.5h7.667c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z" />
          <path d="m23.5 16.333h-7.667c-.276 0-.5.224-.5.5s.224.5.5.5h7.667c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z" />
          <path d="m23.5 20.333h-7.667c-.276 0-.5.224-.5.5s.224.5.5.5h7.667c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z" />
          <path d="m23.5 22.333h-7.667c-.276 0-.5.224-.5.5s.224.5.5.5h7.667c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z" />
        </g>
      </svg>
    ),
    path: "/listagens",
  },
  {
    text: "Modelos",
    icon: (
      <svg
        enable-background="new 0 0 32 32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <path
          d="m22.375 11.833h-.333v3.167c0 1.563-1.271 2.833-2.833 2.833h-7.833v1.5c0 1.011.822 1.833 1.833 1.833h.833v1.5c0 .206.126.391.319.466.059.023.12.034.181.034.137 0 .272-.057.368-.162l1.685-1.838h5.78c1.011 0 1.833-.822 1.833-1.833v-5.667c0-1.01-.822-1.833-1.833-1.833z"
          fill="#5F1BBC"
        />
        <path
          d="m19.208 7.833h-9.666c-.827 0-1.5.673-1.5 1.5v5.667c0 .827.673 1.5 1.5 1.5h9.667c.827 0 1.5-.673 1.5-1.5v-5.667c-.001-.827-.674-1.5-1.501-1.5zm.167 2.96-4.493 2.18c-.16.08-.333.12-.507.12s-.347-.04-.507-.12l-4.493-2.18v-1.106l4.927 2.387c.047.027.1.027.147 0l4.927-2.387v1.106z"
          fill="#5F1BBC"
        />
      </svg>
    ),

    path: "/modelos",
  },
  {
    text: "Campanhas",
    icon: (
      <svg
        id="bold"
        enable-background="new 0 0 32 32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <path
          d="m23.655 8.001c-3.127-.053-6.687 1.58-8.941 4.113-2.154.04-4.254.92-5.8 2.466-.087.087-.12.22-.08.34s.14.207.267.227l2.574.367-.32.36c-.12.127-.113.333.013.453l3.107 3.106c-.18-.353-.213-.76-.08-1.153.193-.58.72-.98 1.333-1.013l1.833-.107.68-1.84c.213-.593.78-.987 1.407-.987s1.193.393 1.407.987l.187.5c1.74-2.173 2.794-4.979 2.74-7.493-.007-.179-.147-.319-.327-.326zm-3.074 5.76c-.327.32-.753.487-1.18.487s-.853-.167-1.18-.487c-.647-.653-.647-1.713 0-2.36.653-.653 1.713-.653 2.36 0 .647.646.647 1.706 0 2.36z"
          fill="#5F1BBC"
        />
        <g fill="#5F1BBC">
          <path d="m9.816 19.269c-.714.713-1.693 3.937-1.802 4.302-.035.118-.003.245.084.331.063.064.148.098.235.098.032 0 .064-.005.096-.014.365-.109 3.588-1.089 4.302-1.802.804-.804.804-2.111 0-2.914-.804-.805-2.111-.804-2.915-.001z" />
          <path d="m22.036 24c-.098 0-.197-.029-.281-.087l-2.088-1.421-2.088 1.421c-.171.116-.398.115-.568-.004-.171-.119-.249-.331-.198-.532l.65-2.566-1.954-1.669c-.155-.132-.214-.346-.149-.54.065-.193.242-.328.446-.34l2.49-.141.902-2.46c.072-.197.26-.328.469-.328s.397.131.469.328l.902 2.46 2.49.141c.204.012.381.146.446.34s.006.408-.149.54l-1.954 1.669.65 2.566c.051.201-.027.413-.198.532-.087.061-.187.091-.287.091z" />
        </g>
      </svg>
    ),
    path: "/campanhas",
  },
  {
    text: "Integrações",
    icon: (
      <svg
        id="bold"
        enable-background="new 0 0 32 32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z"
          fill="#DDD4FF"
        />
        <path
          d="m16 12c1.373 0 2.628.738 3.276 1.925.205.376.579.631 1.004.684 1.361.171 2.386 1.322 2.386 2.677 0 1.496-1.235 2.713-2.753 2.713h-8.48c-1.158 0-2.1-.927-2.1-2.067 0-1.059.805-1.942 1.872-2.054.566-.059 1.031-.471 1.16-1.025.384-1.652 1.913-2.853 3.635-2.853zm0-1.333c-2.36 0-4.413 1.647-4.933 3.887-1.72.179-3.067 1.626-3.067 3.379 0 1.873 1.54 3.4 3.433 3.4h8.48c2.253 0 4.087-1.813 4.087-4.047 0-2.04-1.54-3.747-3.553-4-.874-1.599-2.587-2.619-4.447-2.619z"
          fill="#5F1BBC"
        />
        <g fill="#DDD4FF">
          <path d="m14.5 17.793c.207.187.22.5.04.707-.1.113-.233.167-.373.167-.12 0-.24-.04-.333-.127l-1.667-1.5c-.107-.093-.167-.233-.167-.373s.06-.28.167-.373l1.667-1.5c.207-.18.52-.167.707.04.18.207.167.52-.04.707l-1.253 1.127z" />
          <path d="m17.32 14.613-1 4.333c-.056.246-.28.427-.6.373-.267-.06-.433-.333-.373-.6l1-4.333c.06-.267.333-.433.6-.373.266.06.433.334.373.6z" />
          <path d="m20.5 17.04-1.667 1.5c-.093.087-.213.127-.333.127-.14 0-.273-.053-.373-.167-.18-.207-.167-.52.04-.707l1.253-1.127-1.253-1.127c-.207-.187-.22-.5-.04-.707.187-.207.5-.22.707-.04l1.667 1.5c.107.093.167.233.167.373-.001.142-.061.282-.168.375z" />
        </g>
      </svg>
    ),
    path: "/integrações",
  },
];

const secondaryListItems = []; // remove tipagem any[]

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const setUserAuthenticated = use123zapStore((state) => state.setUserAuthenticated);

  // remove tipagens string e boolean
  function isInPath(path, currentPath) {
    return decodeURIComponent(currentPath).startsWith(path);
  }

  const handleNavigate = (path) => {
    const authStatus = checkAuth();

    if (authStatus === true) {
      navigate(path)
    } else {
      setUserAuthenticated(false);
      navigate("/");
    }
  };

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List>
        {mainListItems.map((item, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{ display: "block", mt: 1 }}
            onClick={() => handleNavigate(item.path)}
          >
            <ListItemButton
              selected={isInPath(item.path, location.pathname)}
              sx={{
                backgroundColor: isInPath(item.path, location.pathname)
                  ? "#F5F3FF"
                  : "#F5F3FF",
                "&.Mui-selected": { backgroundColor: "#DDD4FF !important" },
              }}
            >
              <div
                style={{
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span style={{ fontSize: "0.90rem", marginLeft: "12px", fontWeight: '500' }}>
                      {item.text}
                    </span>
                  }
                />
              </div>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
